{
  "screen": {
    "heading": "Ny patient",
    "explanation": "För en patient som inte finns i journalen. Numret tas från avdelningens förtryckta reservnummerband — journalen delar inte ut nummer själv.",
    "searchFirst": "Sök först. En patient som redan finns i journalen ska inte registreras en andra gång.",
    "noNationalNumber": "Personnummer kan inte anges här. Sök efter patienten först — en patient med personnummer finns oftast redan i journalen. Hittar du inte patienten, registrera med ett reservnummer från bandet.",
    "irreversible": "En registrerad patient kan inte tas bort. Fel rättas genom en ny version.",
    "requiredHint": "Fält utan anmärkning måste fyllas i.",
    "optional": "frivilligt",
    "admitsTo": "Patienten skrivs in på avdelning {ward}.",
    "noWard": "Ingen avdelning kunde hämtas. Patienten kan inte skrivas in utan avdelning.",
    "register": "Registrera patienten",
    "registering": "Registrerar …",
    "cancel": "Avbryt",
    "close": "Stäng",
    "discardQuestion": "Stäng formuläret? Det du har skrivit sparas inte.",
    "discardConfirm": "Stäng utan att registrera",
    "discardCancel": "Fortsätt fylla i",
    "registeredOk": "Patienten är registrerad med {identifier} och finns i journalen.",
    "registeredOnWard": "Inskriven på {ward}.",
    "openPatient": "Öppna patientöversikten",
    "registerAnother": "Registrera en till patient"
  },
  "field": {
    "assigner": "Utfärdat av",
    "givenName": "Förnamn",
    "familyName": "Efternamn",
    "sex": "Kön",
    "isEstimatedIdentity": "Identiteten är antagen, inte styrkt"
  },
  "fieldHint": {
    "identifier": "Läs av numret från bandet, till exempel TST00000001. Tre bokstäver och åtta siffror.",
    "ward": "Avdelningen patienten skrivs in på. Byter du här byter även avdelningslistan.",
    "assigner": "Den enhet som äger nummerserien bandet kommer från.",
    "givenName": "Lämna tomt om namnet inte är känt.",
    "familyName": "Måste fyllas i, eller markera identiteten som antagen nedan.",
    "birthDate": "ÅÅÅÅ-MM-DD. Lämna tomt om födelsedatumet inte är känt.",
    "bed": "Rum och plats som personalen säger dem. Lämna tomt om det inte finns någon plats just nu, eller om patienten ligger i korridor — patienten står då sist i avdelningslistan, utan plats.",
    "isEstimatedIdentity": "För en patient som inte kan identifieras. Journalen visar då att namn och födelsedatum är ett antagande.",
    "identifierDemo": "Testmiljö: här finns inga band att läsa av. Hitta på ett nummer som börjar med TST8000 och sluta med fyra egna siffror, till exempel TST80001234. Är numret upptaget säger formuläret det — välj då fyra andra siffror."
  },
  "sex": {
    "notAnswered": "Inte angivet"
  },
  "refusal": {
    "identifierMissing": "Fyll i reservnummret från bandet.",
    "identifierIsNationalNumber": "Det ser ut som ett personnummer, och personnummer kan inte anges här. Sök efter patienten i stället. Hittar du inte patienten, registrera med ett reservnummer från bandet. Numret skickades inte.",
    "identifierMalformed": "Reservnummret godtas inte. Det ska vara {letters} bokstäver följda av {digits} siffror.",
    "identifierInUse": "{identifier} finns redan i journalen. Patienten registrerades inte igen — öppna patienten i stället.",
    "assignerMissing": "Fyll i vilken enhet som äger nummerserien.",
    "familyNameMissing": "Fyll i efternamn, eller markera identiteten som antagen.",
    "fieldTooLong": "{field} är för långt. Korta ner till högst {maximum} tecken.",
    "sexUnknown": "Könet godtas inte. Välj ett av alternativen i listan.",
    "birthDateMalformed": "Födelsedatumet godtas inte. Skriv det som ÅÅÅÅ-MM-DD, eller lämna fältet tomt.",
    "birthDateInFuture": "Födelsedatumet ligger i framtiden.",
    "wardMissing": "Ingen avdelning är vald. Patienten registrerades inte.",
    "wardNotFound": "Avdelning {ward} finns inte i journalen. Patienten registrerades inte.",
    "roleMayNotDocument": "Din roll får inte dokumentera i journalen. Patienten registrerades inte.",
    "unknown": "Patienten registrerades inte. Försök igen.",
    "unavailable": "Ingen kontakt med servern. Patienten registrerades inte — låt formuläret vara öppet och försök igen."
  }
}
